import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/support-section/global.json'

export const SUPPORT_SECTION_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
